<template>
  <div v-if="lot && program && !loading">
    <sticky class="page-header sticky-page-header page-header--new" :back-button="true">
      <span slot="left-title">Edition du lot {{lot.ref}}</span>
    </sticky>
    <div class="columns is-gapless is-margin-left-on-btn-actions is-margin-right-on-btn-actions is-padding-top">
      <div class="column is-12 is-9-widescreen is-8-fullhd">
        <div class="has-bg-white is-border">
          <lot-form @submit="submit"
                    :source="lot"
                    :program="program"
                    :loading="saving"
                    :edit="true"
                    :select-panel="selectPanel"
          ></lot-form>
        </div>
      </div>
    </div>
  </div>
  <spinner-round v-else :isLoading="loading"></spinner-round>

</template>

<script>
  import LotForm from '@/components/lot/LotForm'

  export default {
    name: 'LotCreate',
    data () {
      return {
        loading: true,
        program: null,
        lot: null,
        saving: false,
        selectPanel: null
      }
    },
    components: {
      LotForm
    },
    methods: {
      getLot (id) {
        this.loading = true
        this.$api.lotService.getOne(id).then(res => {
          this.lot = res.data
          this.getProgram(res.data.program)
        }).catch(() => {
          this.loading = false
        })
      },
      submit (lot) {
        this.saving = true
        this.$api.lotService.put(lot.pk, lot).then(res => {
          this.saving = false
          this.$notify({
            type: 'is-success',
            text: 'Le lot a bien été mise à jour.'
          })
          this.$router.goBack(this.$route)
        }).catch(() => {
          this.saving = false
          this.$notify({
            type: 'is-danger',
            text: 'Erreur lors de la mise à jour du lot.'
          })
        })
      },
      getProgram (programPk) {
        this.$api.programService.getOne(programPk).then(r => {
          this.program = r.data
          this.loading = false
        })
      }
    },
    created () {
      this.getLot(this.$route.params.id)
      if (this.$route.query && this.$route.query.panel) {
        this.selectPanel = this.$route.query.panel
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/lot/LotEdit.vue